export const workspace = ['uhp', 'uaep', 'htp', 'mcii']